export class SidePanel{
	init(){
		if(typeof sidePanelOptions == 'object'){
			var self = this,
				cookieFlag = self.getCookie('side-panel-'+sidePanelOptions.siteId),
				currentCookie = (cookieFlag != null) ? JSON.parse(cookieFlag) : null,
				body = $('body');

			$(document).ready(function() {
				if(currentCookie == null || (currentCookie.id != sidePanelOptions.id)){
					sidePanelOptions.closed = 0;
					self.setCookie('side-panel-'+sidePanelOptions.siteId, JSON.stringify(sidePanelOptions), 365);
					self.checkRevealType();
				}else{
					if(	(currentCookie.closed == 0 && sidePanelOptions.reactive == 0) || 
						(currentCookie.closed == 1 && currentCookie.reactive == 0 &&  sidePanelOptions.reactive == 1)){
						self.checkRevealType();						
					}
				}

				body.on('click', '.side-panel__close', function() {
					self.hidePanel();
				});
				body.on('click', '.side-panel.close', function() {
					self.reopenPanel();
				});
			});
		}
	}
	reopenPanel(){
		$('.side-panel').fadeOut(function () {
			$(this).removeClass('close').addClass('open').fadeIn();
		});
	}
	showPanel(){
		$('.side-panel').fadeIn(function () {
			$(this).removeClass('close').addClass('open');
		});
	}
	hidePanel(){
		var self = this;
		$('.side-panel').fadeOut(function(){
			$(this).removeClass('open').addClass('close').show();
		});
		var cookie = self.getCookie('side-panel-'+sidePanelOptions.siteId);
		var parsedCookie = JSON.parse(cookie);

		parsedCookie.closed = 1;
		(sidePanelOptions.reactive == 1) ? parsedCookie.reactive = 1 : parsedCookie.reactive = 0;
		self.setCookie('side-panel-'+sidePanelOptions.siteId, JSON.stringify(parsedCookie), 365);
	}
	showAfterTime(time){
		var self = this;
		var delay = parseInt(time)*1000;
		setTimeout(function() {
			self.showPanel()
		}, delay);
	}
	showAfterDistance(distance){
		var self = this,
			notClosed = true;
		$(window).scroll(function() {
			var st = $(window).scrollTop();

			if(st > distance && notClosed){
				self.showPanel();
				notClosed = false;
			}			
		})
	}
	checkRevealType(){
		var self = this;

		if(sidePanelOptions.distance != 0){
			self.showAfterDistance(sidePanelOptions.distance);
		}else if(sidePanelOptions.time != 0){
			self.showAfterTime(sidePanelOptions.time);
		}
	}
	getCookie(name) {
	    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	    return v ? v[2] : null;
	}
	setCookie(name, value, days) {
	    var d = new Date;
	    d.setTime(d.getTime() + 24*60*60*1000*days);
	    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
	}
}